module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login",
    staticStyle: {
      "background-size": "100% 100%"
    },
    style: (_vm.backgroundType)
  }, [_c('div', {
    staticClass: "loginHeader"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })])]), _vm._v(" "), (_vm.showSelectHotel) ? [_c('div', {
    staticClass: "hotel-list"
  }, [_vm._l((_vm.hotelList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "hotel-list-item",
      class: {
        active: _vm.currentHotel.unitCode == item.unitCode
      },
      on: {
        "click": function($event) {
          return _vm.selectHotel(item)
        }
      }
    }, [_c('div', {
      staticClass: "hotelname"
    }, [_vm._v(_vm._s(item.unitCode || ''))]), _vm._v(" "), _c('div', {
      staticClass: "username"
    }, [_vm._v(_vm._s(item.userCode))])])
  }), _vm._v(" "), (_vm.hotelList.length) ? _c('div', {
    staticClass: "centerIn",
    staticStyle: {
      "padding-top": "70px"
    }
  }, [_c('mt-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.goLoginLYD
    }
  }, [_vm._v(_vm._s(_vm.$t('login_login')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingLVD && !_vm.hotelList.length) ? _c('div', {
    staticClass: "no-hotel"
  }, [_vm._v("\n          暂无酒店，请联系管理员\n        ")]) : _vm._e()], 2)] : [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoginForm),
      expression: "showLoginForm"
    }]
  }, [_c('div', {
    staticClass: "loginForm",
    attrs: {
      "id": "input-text-box"
    },
    on: {
      "click": _vm.goAnchor
    }
  }, [_c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('login_hotelCode')
    },
    model: {
      value: (_vm.formOption.hotelCode),
      callback: function($$v) {
        _vm.$set(_vm.formOption, "hotelCode", $$v)
      },
      expression: "formOption.hotelCode"
    }
  }), _vm._v(" "), _c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('login_username')
    },
    model: {
      value: (_vm.formOption.username),
      callback: function($$v) {
        _vm.$set(_vm.formOption, "username", $$v)
      },
      expression: "formOption.username"
    }
  }), _vm._v(" "), (_vm.formOption.password.length < 100) ? _c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('login_password'),
      "type": "password"
    },
    model: {
      value: (_vm.formOption.password),
      callback: function($$v) {
        _vm.$set(_vm.formOption, "password", $$v)
      },
      expression: "formOption.password"
    }
  }) : _c('mt-field', {
    attrs: {
      "placeholder": _vm.$t('login_password'),
      "type": "text"
    },
    nativeOn: {
      "input": function($event) {
        _vm.formOption.password = ''
      }
    },
    model: {
      value: (_vm.vsave),
      callback: function($$v) {
        _vm.vsave = $$v
      },
      expression: "vsave"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "centerIn"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('login_login')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "remember"
  }, [_c('mt-checklist', {
    attrs: {
      "options": [_vm.$t('login_pleseRemember')]
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), (_vm.uuid) ? _c('div', {
    staticClass: "only-code",
    on: {
      "click": _vm.showOnlyCode
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('login_only_code')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vue-select"
  }, [_c('p', {
    class: {
      isOpen: _vm.selectHelpVisibility
    },
    on: {
      "click": _vm.changeSelectVisibility
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curLanguage))]), _vm._v(" "), _c('i', {
    staticClass: "mint-cell-allow-down"
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectHelpVisibility),
      expression: "selectHelpVisibility"
    }]
  }, _vm._l((_vm.options), function(item) {
    return _c('li', {
      key: item.code,
      on: {
        "click": function($event) {
          return _vm.changeLanguage(item)
        }
      }
    }, [_vm._v(_vm._s(item.value))])
  }), 0)])])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c7398644","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/login.vue
// module id = 1837
// module chunks = 107